
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2[379]|3[679]|54)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
